/**
 * Social Integrations Registry
 * ---------------------------------------------------------------------
 * Central config for external community channels. Adding a new channel
 * (WhatsApp / Discord / Instagram / YouTube / LinkedIn) is a one-object
 * change here — sidebar, Dashboard card, Landing section, and Settings
 * page all read from the same source so nothing goes out of sync.
 *
 * Contract for each entry:
 *   id            unique slug ("telegram", "discord", ...)
 *   name          human-readable label
 *   url           canonical join URL (opens in new tab)
 *   description   1-line pitch used in cards
 *   sidebar       whether to render in the sidebar
 *   dismissKey    key on server-side social_prefs (POST /api/<id>/dismiss)
 *
 * Adding a new channel:
 *   1. Add the entry below.
 *   2. Extend the backend `social_prefs` map + POST /api/<id>/dismiss.
 *   3. Everything else is automatic.
 */
export const SOCIAL_CHANNELS = {
  telegram: {
    id: "telegram",
    name: "Telegram Channel",
    shortLabel: "Telegram",
    url: "https://t.me/sylloxin",
    handle: "@sylloxin",
    description:
      "Get free Notes, DPPs, PYQs, study resources, feature updates, YouTube videos, and important announcements directly on Telegram.",
    // Extra tagline used only on the Landing page hero section (avoids duplication)
    landingDescription:
      "Join thousands of students and receive free Notes, DPPs, PYQs, study resources, important announcements, feature updates, YouTube videos, and exam updates.",
    brandColor: "#26A5E4",     // Official Telegram blue
    brandFrom: "from-sky-500",  // Tailwind gradient tokens for card treatments
    brandTo: "to-cyan-500",
    sidebar: true,
    dismissEndpoint: "/telegram/dismiss",
    resetEndpoint: "/telegram/reset",
    // Server field on /me/access.social_prefs that gates the Dashboard card.
    prefKey: "telegram_dismissed",
  },
  // Future channels drop in here — no other file needs to change.
};

/** Utility: open a channel URL in a new tab with security-safe attrs. */
export function openChannel(channelId) {
  const c = SOCIAL_CHANNELS[channelId];
  if (!c) return;
  // noopener + noreferrer prevents the target page from getting a handle
  // back to this window (rel is not enough for programmatic opens).
  const w = window.open(c.url, "_blank", "noopener,noreferrer");
  if (w) w.opener = null;
}
